import React, { useEffect } from "react";
import "./Product_Info_Card.css";
import Green_Outline_Btn from "../common_btn/green_outline_btn/Green_Outline_Btn";
import Best_seller_heart from "../product_card/Best_seller_heart/Best_seller_heart";
import Add_to_card_btn from "../common_btn/Add_to_card_btn/Add_to_card_btn";
import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import { useSelector, useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import { appSetup } from "../../../features/master/masterSlice";

const Product_Info_Card = ({
  id,
  imgSrc,
  vdoSrc,
  productName,
  productDesignId,
  priceText,
  mrp,
  savingPrice,
  prodDiscount,
  product,
}) => {
  const dispatch = useDispatch();

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  return (
    <div className="Product_Info_Card">
      {/* <Link to={`/product-details/${encodeId(product?.id)}`}> */}
      <Link to={`/product-details/${product?.id}`}>
        <div className="prod_img_holder">
          {/* <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{
              clickable: true,
              dynamicBullets: true,
              dynamicMainBullets: 3, // shows about 3 main bullets
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            className="product_card_swiper"
          >
            {product?.Product_Images?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="inner_img_holder">
                  <img
                    src={item?.image}
                    className="prod_img"
                    alt={productName}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}
          {/* <div className="discount">{prodDiscount}% {" "}Off</div> */}

          {(() => {
            const discountPercentage =
              Number(prodDiscount) > 0
                ? Number(prodDiscount)
                : Number(product?.p_category?.cat_discount) > 0
                ? Number(product.p_category.cat_discount)
                : Number(app_setup?.global_discount) > 0
                ? Number(app_setup.global_discount)
                : 0;

            return discountPercentage > 0 ? (
              <div className="discount">{discountPercentage}% Off</div>
            ) : null;
          })()}
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{
              clickable: true,
              dynamicBullets: true,
              dynamicMainBullets: 3,
            }}
            // autoplay={{
            //   delay: 3000,
            //   disableOnInteraction: false,
            // }}
            className="product_card_swiper"
          >
            {product?.Product_Images?.length > 0 ? (
              product.Product_Images.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="inner_img_holder">
                    <img
                      src={item.image}
                      className="prod_img"
                      alt={productName}
                    />
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <SwiperSlide>
                <div className="inner_img_holder">
                  <img src={imgSrc} className="prod_img" alt={productName} />
                </div>
              </SwiperSlide>
            )}
          </Swiper>
          {/* <img src={imgSrc} className="prod_img" alt={productName} /> */}
        </div>
      </Link>

      <div className="best_seller_heart_holder">
        <Best_seller_heart
          product={product}
          productDesignId={productDesignId}
        />
      </div>

      <div className="content_holder">
        <div className="middle_div">
          {/* <Link to={`/product-details/${encodeId(product?.id)}`}> */}
          <Link to={`/product-details/${product?.id}`}>
            <p className="prod_name">
              {productName} {"("}
              {productDesignId}
              {")"}
            </p>
          </Link>
          {/* <div className="price_div">
            <p className="mrp_text">
            {symbol}{mrp}
            </p>
            <p className="s_price_text">
              {symbol}
              {priceText}
            </p>
          </div> */}

          <div className="price_div">
            {(() => {
              const discountPercentage =
                Number(prodDiscount) > 0
                  ? Number(prodDiscount)
                  : Number(product?.p_category?.cat_discount) > 0
                  ? Number(product.p_category.cat_discount)
                  : Number(app_setup?.global_discount) > 0
                  ? Number(app_setup.global_discount)
                  : 0;

              const originalPrice = Number(priceText || 0);

              const discountedPrice =
                originalPrice * (1 - discountPercentage / 100);

              return discountPercentage > 0 ? (
                <>
                  <p
                    className="s_price_text"
                    style={{
                      textDecoration: "line-through",
                      marginRight: "8px",
                      display: "inline-block",
                    }}
                  >
                    {symbol}
                    {(originalPrice * rate).toFixed(2)}
                  </p>

                  <p
                    className="s_price_text"
                    style={{ display: "inline-block" }}
                  >
                    {symbol}
                    {(discountedPrice * rate).toFixed(2)}
                  </p>
                </>
              ) : (
                <p className="s_price_text">
                  {symbol}
                  {(originalPrice * rate).toFixed(2)}
                </p>
              );
            })()}
          </div>
        </div>

        <div className="btn_holder">
          <Add_to_card_btn
            id={product?.id}
            product={product}
            item_id={product?.id}
          />
        </div>
      </div>
    </div>
  );
};

export default Product_Info_Card;
